import { render, staticRenderFns } from "./participa.vue?vue&type=template&id=83d1ce1a&"
import script from "./participa.vue?vue&type=script&lang=js&"
export * from "./participa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports